import React from 'react'

/**
 * Page header/footer frame for non-cover pages.
 * Adds a small logo + title header and a copyright + page number footer.
 * Wraps children in the middle with flex-grow so footer sticks to bottom.
 */
const PageFrame = ({ theme, children, pageNumber, totalPages, entityNameFormal }) => {
  const footerText = ` - ${entityNameFormal || 'Handyman Maintenance, Inc.'} - All Rights Reserved`
  return (
    <div className="proposal-page-frame">
      {/* Header */}
      <div className="proposal-page-frame__header">
        <div className="proposal-page-frame__header-left">
          {theme?.logoUrl && (
            <img
              src={theme.logoUrl}
              alt="Logo"
              className="proposal-page-frame__header-logo"
            />
          )}
          <span className="proposal-page-frame__header-title">
            Landscape Maintenance Proposal
          </span>
        </div>
      </div>

      {/* Accent bar under header */}
      <div className="proposal-page-frame__accent-bar" />

      {/* Page content */}
      <div className="proposal-page-frame__content">
        {children}
      </div>

      {/* Footer */}
      <div className="proposal-page-frame__footer">
        <div className="proposal-page-frame__footer-left">
        &copy;{new Date().getFullYear()} {footerText}
         
        </div>
        {pageNumber && (
          <div className="proposal-page-frame__footer-right">
            {pageNumber}{totalPages ? ` of ${totalPages}` : ''}
          </div>
        )}
      </div>
    </div>
  )
}

export default PageFrame
